import styled from 'styled-components';

export const StyledReportApplicationFormContainer = styled.div`
  .select {
    position: relative;
      
    img.down {
      position: absolute;
      width: 10px;
      right: 15px;
      top: 37%;
    }
    
    img.clear {
      position: absolute;
      width: 15px;
      right: 15px;
      top: 32%;
    }
  }
`;